export default __webpack_public_path__ + "static/media/startupmanch-blue.565f3d89.svg";